export default "__VITE_ASSET__CTjgEdYb__"